import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactSelect, { components } from '@naoned-systemes/react-select'
import _ from 'lodash'
import {
    removeAccents,
    toLowerCase,
} from '../../../../../helpers/string'
import { withTranslation } from 'react-i18next'

class Select extends Component
{
    static propTypes = {
        t: PropTypes.func.isRequired,
        onChange: PropTypes.func.isRequired,
        options: PropTypes.array.isRequired,
        value: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string,
        ]).isRequired,
        isSearchable: PropTypes.bool,
        isDisabled: PropTypes.bool,
        className: PropTypes.string,
        placeholder: PropTypes.string,
        doNotFilterValue: PropTypes.string,
        hasFocus: PropTypes.bool,
        forwardedRef: PropTypes.object,
    }

    constructor(props)
    {
        super(props)

        this.filterOption = this.filterOption.bind(this)
        this.selectedOption = this.selectedOption.bind(this)
    }

    filterOption(option, inputValue)
    {
        const { doNotFilterValue } = this.props
        const { label, value } = option
        const normalizedLabel = toLowerCase(removeAccents(label))
        const normalizedInputValue =  toLowerCase(removeAccents(inputValue))

        return normalizedLabel.includes(normalizedInputValue) || (doNotFilterValue !== undefined && value === doNotFilterValue)
    }

    selectedOption()
    {
        const { options, value } = this.props

        return _.find(options, (option) => option.value === value)
    }

    render()
    {
        const {
            t,
            options,
            onChange,
            isSearchable = false,
            isDisabled = false,
            className = '',
            placeholder = '',
            hasFocus = false,
            forwardedRef,
        } = this.props

        const Option = props => (
            <div title={props.data.label}>
                <components.Option {...props} />
            </div>
        )

        return <ReactSelect
            ref={forwardedRef}
            components={{Option}}
            options={options}
            value={this.selectedOption()}
            onChange={onChange}
            filterOption={this.filterOption}
            isMulti={false}
            isClearable={false}
            isDisabled={isDisabled}
            isSearchable={isSearchable}
            className={`enhanced-select ${className}`}
            classNamePrefix={"enhanced-select"}
            noOptionsMessage={() => t('visualizer:common.noOption')}
            placeholder={placeholder}
            menuPlacement={'auto'}
            autoFocus={hasFocus}
        />
    }
}

export default withTranslation()(Select)
